<formulario-teste [id]="id"
    (onNovaVersaoGerada)="changeVersao()"
    (onEntidadeSalva)="setEntidade($event)"
></formulario-teste>

<ng-container *ngIf="id">
    <container-padrao>
        <modulos-testes #modulosComponent [teste]="teste"></modulos-testes>
    </container-padrao>
</ng-container>

<ng-container *ngIf="id">
    <container-padrao>
        <materiais-curso [id]="id"></materiais-curso>
    </container-padrao>
</ng-container>

